const downloadPdf = (blob, documentName) => {
  const sanitizedDocumentName = documentName
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .trim();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = sanitizedDocumentName;
  link.click();
  URL.revokeObjectURL(blobUrl);
};

export default downloadPdf;

// import JSZip from "jszip";
// import { saveAs } from "file-saver";

// const downloadPdf = async (
//   pdfBlob,
//   documentName,
//   registrationId,
//   patientName,
//   hospitalName
// ) => {
//   try {
//     const sanitizedDocumentName =
//       documentName?.replace(/[^a-zA-Z0-9 ]/g, "").trim() || "Document";

//     const folderName = `${registrationId}_${patientName}_${hospitalName}`;

//     const zip = new JSZip();
//     const folder = zip.folder(folderName);

//     folder.file(`${registrationId}_${sanitizedDocumentName}.pdf`, pdfBlob);

//     const zipBlob = await zip.generateAsync({ type: "blob" });

//     saveAs(zipBlob, `${folderName}.zip`);
//   } catch (err) {
//     console.error("Error while zipping and downloading PDF:", err);
//   }
// };

// export default downloadPdf;
